/**
 * @fileOverview This file contains the implementation of the hook to manage the tour/tutorial in Visits module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import { Typography } from "@mui/material";
import { useTranslationHook } from "../hooks/UseTranslationHook";

const useVisitsTour = (setModalVShow) => {
  const {
    visitsS1P1,
    visitsS1P2,
    visitsS2P1,
    visitsS2P2,
    visitsS3P1,
    visitsS3P2,
    visitsS3P3,
    visitsS3P4,
    visitsS3P5,
    visitsS4P1,
    visitsS4P2,
    visitsS5P1,
    visitsS5P2,
  } = useTranslationHook();

  return [
    {
      selector: ".create-visit-tour",
      content: (
        <Typography>
          <strong>{visitsS1P1}</strong> {visitsS1P2}
        </Typography>
      ),
      action: () => setModalVShow(false),
      stepInteraction: false,
    },
    {
      content: (
        <Typography>
          {visitsS2P1} <strong>{visitsS2P2}</strong>.
        </Typography>
      ),
      action: () => setModalVShow(true),
      stepInteraction: false,
    },
    {
      selector: ".create-visit-form-tour",
      content: (
        <Typography>
          {visitsS3P1} <strong>{visitsS3P2}</strong>. {visitsS3P3}{" "}
          <strong>{visitsS3P4}</strong> {visitsS3P5}
        </Typography>
      ),
      action: () => setModalVShow(true),
      stepInteraction: false,
    },
    {
      selector: ".visits-datagrid-tour",
      content: (
        <Typography>
          {visitsS4P1} <strong>{visitsS4P2}</strong>.
        </Typography>
      ),
      action: () => setModalVShow(false),
      stepInteraction: false,
    },
    {
      selector: ".visits-datagrid-actions-tour",
      content: (
        <Typography>
          {visitsS5P1} <strong>{visitsS5P2}</strong>.
        </Typography>
      ),
      action: () => setModalVShow(false),
      stepInteraction: false,
    },
  ];
};

export default useVisitsTour;
